import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FiSettings, FiUser, FiShield } from 'react-icons/fi'
import FormInput from '../../components/FormInput/FormInput'
import Button from '../../components/Button/Button'
import './Settings.css'

const Settings = () => {
  const { user } = useSelector((state) => state.auth)
  const [profileData, setProfileData] = useState({
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    email: user?.email || '',
    phone: user?.phone || '',
  })

  const handleProfileUpdate = async (e) => {
    e.preventDefault()
    // TODO: Implement profile update API call
    console.log('Update profile:', profileData)
  }

  return (
    <div className="settings-page">
      <header className="page-header">
        <div>
          <p className="eyebrow">Configuration</p>
          <h1>Settings</h1>
          <p className="subhead">Manage your account and system preferences</p>
        </div>
      </header>

      <div className="settings-grid">
        <section className="settings-section">
          <div className="section-header">
            <FiUser size={20} />
            <h2>Profile Settings</h2>
          </div>
          <form onSubmit={handleProfileUpdate}>
            <FormInput
              label="First Name"
              name="firstName"
              value={profileData.firstName}
              onChange={(e) => setProfileData({ ...profileData, firstName: e.target.value })}
            />
            <FormInput
              label="Last Name"
              name="lastName"
              value={profileData.lastName}
              onChange={(e) => setProfileData({ ...profileData, lastName: e.target.value })}
            />
            <FormInput
              label="Email"
              name="email"
              type="email"
              value={profileData.email}
              disabled
            />
            <FormInput
              label="Phone"
              name="phone"
              value={profileData.phone}
              onChange={(e) => setProfileData({ ...profileData, phone: e.target.value })}
            />
            <Button type="submit">Update Profile</Button>
          </form>
        </section>

        <section className="settings-section">
          <div className="section-header">
            <FiShield size={20} />
            <h2>Security</h2>
          </div>
          <div className="security-info">
            <p>Change your password and manage security settings.</p>
            <Button variant="secondary">Change Password</Button>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Settings

